import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomePage.vue';
import LobbyView from '../views/LobbyView.vue';
import RoomView from '../views/RoomView.vue';
import GameView from '../views/GameView.vue';
import GameOver from '../views/GameOver.vue';

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/lobby', name: 'Lobby', component: LobbyView },
  { path: '/room/:roomId', name: 'Room', component: RoomView },
  { path: '/game/:roomId', name: 'Game', component: GameView },
  { path: '/gameover/:roomId', name: 'GameOver', component: GameOver },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
